import {
  Component,
  ChangeDetectionStrategy,
  Input,
  AfterViewInit,
  QueryList,
  OnChanges,
  SimpleChanges,
  ContentChildren,
  ContentChild,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

import { GasInputLabelComponent } from '../label/gas-input-label.component';
import { GasInputFieldComponent } from '../field/gas-input-field.component';
import { GasForm } from '../../gas-form.namespace';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

/** @see https://www.figma.com/file/yqBeq1MiGfpdN62SvmA8tg/RTLABS_GAS_DS_1?node-id=589%3A5592 */
@UntilDestroy()
@Component({
  selector: 'gas-input-wrapper',
  templateUrl: './gas-input-wrapper.component.html',
  styleUrls: ['./gas-input-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasInputWrapperComponent implements AfterViewInit, OnChanges {
  @Input()
  public type: GasForm.InputState = GasForm.InputState.Default;

  @ContentChild(GasInputFieldComponent)
  public inputComponent: GasInputFieldComponent;

  @ContentChildren(GasInputLabelComponent, { descendants: true })
  public inputLabelComponents: QueryList<GasInputLabelComponent>;

  private typeSubject$ = new BehaviorSubject<GasForm.InputState>(GasForm.InputState.Default);
  private initedSubject$ = new BehaviorSubject<boolean>(false);

  constructor() {
    /**
     * Нужно в конструкторе, ввиду того, что там идет эмит значений из ngOnChanges
     * А внутри этого метода идет подписка на сабжект, который изменяется при ngOnChanges
     * В нем нужно дождаться ngAfterViewInit и только после этого выдавать изменения
     */
    this.initTypeHandler();
  }

  public ngAfterViewInit(): void {
    this.initedSubject$.next(true);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.type?.currentValue) {
      this.typeSubject$.next(changes.type?.currentValue);
    }
  }

  private initTypeHandler(): void {
    /** Слушаем изменения типов */
    this.typeSubject$.asObservable()
      .pipe(
        /** Но только после ngAfterViewInit */
        switchMap((type: GasForm.InputState) => this.initedSubject$.asObservable()
          .pipe(
            filter(Boolean),
            map(() => type),
            untilDestroyed(this),
          )),
      )
      .subscribe((type: GasForm.InputState) => {
        const types: GasForm.InputState[] = [
          GasForm.InputState.Default,
          GasForm.InputState.Primary,
          GasForm.InputState.Success,
          GasForm.InputState.Error,
        ];

        /** При совпадении типа, нужно удалить остальные классы */
        types
          .filter((filteredType: GasForm.InputState) => filteredType !== type)
          .forEach((eachType: GasForm.InputState) => {
            this.inputComponent.renderer.removeClass(this.inputComponent.elementRef.nativeElement, `_${eachType}`);
          });

        /** Добавляем класс с типом */
        this.inputComponent.renderer.addClass(this.inputComponent.elementRef.nativeElement, `_${type}`);
      });
  }
}
